import type {ReactElement} from 'react'
import {exhaustive} from '@freckle/exhaustive'
import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {UnauthenticatedFooter} from '@freckle/educator-materials/ts/components/footer/unauthenticated-footer'
import {login, signup, resetByEmail, onboarding, changePassword} from './page-wrapper.module.scss'

export type PageTypeT =
  | 'login'
  | 'signup'
  | 'resetByEmail'
  | 'resetByEmailSuccess'
  | 'onboarding'
  | 'changePassword'

type Props = {
  pageType: PageTypeT
  children?: ReactElement
}

const pageTypeStyle = (pageType: PageTypeT) => {
  switch (pageType) {
    case 'login':
      return login
    case 'signup':
      return signup
    case 'resetByEmail':
      return resetByEmail
    case 'resetByEmailSuccess':
      return resetByEmail
    case 'onboarding':
      return onboarding
    case 'changePassword':
      return changePassword
    default:
      return exhaustive(pageType)
  }
}
export function PageWrapper(props: Props) {
  const footer =
    props.pageType === 'signup' || props.pageType === 'login' ? <UnauthenticatedFooter /> : null

  return (
    <div className={pageTypeStyle(props.pageType)}>
      <Flex flexDirection="column" alignItems="center">
        {props.children}
      </Flex>
      {footer}
    </div>
  )
}
